export default "__VITE_ASSET__BVfkGofX__"